import type { ReactNode } from 'react';
import type { TopbarButtonBaseProps } from './base/TopbarButton';

import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { FloppyDiskIcon } from '../../../images/shapes';

import Loader from '../../Loader/Loader';
import TopbarButton from './base/TopbarButton';

interface TopbarSaveButtonProps extends TopbarButtonBaseProps {
  /**
   * Form id, if not provided form submission should be handled by onClick property
   */
  form?: string;
  /**
   * Reference to navigate on save property
   */
  navigateOnSave?: any;
  /**
   * If save form is in progress
   */
  isLoading?: boolean;
  /**
   * Button label, default "Save"
   */
  label?: ReactNode;
  /**
   * Click handler — used when form id is not provided
   */
  onClick?: () => void;
}

const TopbarSaveButton = ({
  form,
  isLoading = false,
  navigateOnSave: navigateOnSaveRef,
  label,
  onClick: onClickProp,
  ...props
}: TopbarSaveButtonProps) => {
  const { t } = useTranslation();

  const onClick = useCallback(() => {
    if (navigateOnSaveRef) navigateOnSaveRef.current = false;
    onClickProp?.();
  }, [navigateOnSaveRef, onClickProp]);

  return (
    <TopbarButton
      buttonColor="blue"
      iconImage={
        isLoading ? (
          <Loader size="small" type="spinner-grid" />
        ) : (
          <FloppyDiskIcon className="w-3 min-w-3" />
        )
      }
      label={label || t('Global.Save')}
      onClick={onClick}
      testIdSuffix="save"
      {...(form ? { form, type: 'submit' } : {})}
      {...props}
    />
  );
};

export default TopbarSaveButton;
